<div class="table-head shimmer">
    <!-- <span class="head shimmer" *ngFor="let number of [0,1,2,3,4]">
        <b>Content head loading.. </b>
    </span> -->
</div>
<div class="table-list" *ngFor="let number of colNumbers" [class.gap-3]="minWidth">
    <span class="context shimmer" *ngFor="let number of rowNumbers">
        <b>Content text loading.. </b>
    </span>
</div>
<div class="paginator" [class.minPagi]="minWidth" *ngIf="!set2">
    <div class="pgdata1">
        <span class="context shimmer">
            <b> paginator$loading.. </b>
        </span>
    </div>
    <div class="pgdata2">
        <span class="context shimmer">
            <b> loading.. </b>
        </span>
    </div>
    <div class="pgdata3">
        <span class="context shimmer">
            <b> loading.. </b>
        </span>
    </div>
</div>